var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-3" },
              [
                _c("img", {
                  staticClass: "logo",
                  attrs: {
                    src: require("../assets/img/novonordisk.png"),
                    alt: "Logo"
                  }
                }),
                _vm._v(" "),
                _c("h4", {
                  domProps: { innerHTML: _vm._s(_vm.data.auth.authHeader) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", {
                      attrs: { for: "pwd" },
                      domProps: {
                        innerHTML: _vm._s(_vm.data.auth.pwdEnterLabel)
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        disabled:
                          _vm.$route.query.access &&
                          _vm.$route.query.access.length > 0,
                        placeholder: _vm.data.auth.pwdPlaceholder,
                        id: "pwd"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.enterKeyHandler()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          staticClass: "form-check-input cursor-pointer",
                          attrs: { id: "pwd-check", type: "checkbox" },
                          on: {
                            change: function($event) {
                              return _vm.showPwd()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.showOrHide
                          ? _c("label", {
                              staticClass: "form-check-label cursor-pointer",
                              attrs: { for: "pwd-check" },
                              domProps: {
                                innerHTML: _vm._s(_vm.data.auth.pwdShowLabel)
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showOrHide
                          ? _c("label", {
                              staticClass: "form-check-label cursor-pointer",
                              attrs: { for: "pwd-check" },
                              domProps: {
                                innerHTML: _vm._s(_vm.data.auth.pwdHideLabel)
                              }
                            })
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix--min" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-consent btn-primary btn-md btn-block",
                      attrs: {
                        disabled: _vm.password.length < 3 || _vm.loginStarted,
                        id: "btn-ok"
                      },
                      on: {
                        click: function($event) {
                          return _vm.auth()
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card card-clear-pwd" }, [
                  _c("small", [
                    _c(
                      "span",
                      {
                        staticClass: "cursor-pointer",
                        class: _vm.loginStarted ? "disabled" : "",
                        on: {
                          click: function($event) {
                            return _vm.clearPwd()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.data.auth.pwdClearLabel) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("small", {
                  staticClass: "text-left",
                  domProps: { innerHTML: _vm._s(_vm.data.auth.authDisclaimer) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "alert",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.success,
                        expression: "success"
                      }
                    ],
                    staticClass: "alert alert-success"
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.data.auth.pwdSuccess) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "alert",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.alert,
                        expression: "alert"
                      }
                    ],
                    staticClass: "alert alert-danger"
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.error.errorAuthText)
                      }
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b7575d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7575d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth.vue
// module id = null
// module chunks = 